import { getToken } from "./utils"

// src/api/events.js
const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:8000") + "/events";

async function buildApiError(response, fallbackMessage) {
  let message = fallbackMessage;

  try {
    const payload = await response.json();
    const detail = payload?.detail ?? payload?.message ?? payload;

    if (Array.isArray(detail)) {
      message = detail
        .map((item) => {
          if (typeof item === "string") return item;
          const path = Array.isArray(item?.loc) ? item.loc.join(" > ") : "";
          const reason = item?.msg || item?.message || JSON.stringify(item);
          return path ? `${path}: ${reason}` : reason;
        })
        .join("\n");
    } else if (typeof detail === "object" && detail !== null) {
      message = detail?.msg || detail?.message || JSON.stringify(detail);
    } else if (detail) {
      message = String(detail);
    }
  } catch (_error) {
    try {
      const text = await response.text();
      if (text) {
        message = text;
      }
    } catch (_textError) {
      // ignore
    }
  }

  return new Error(message);
}

// export async function saveEvent({ templateId, json, thumbnail }) {
//   var payload = {
//     "title": "TEST",
//     "background_image": "thumbnail",
//     "event_date": new Date(),
//     "event_type_id": "1",
//     "template_id": templateId,
//     "htmltext": JSON.stringify(json),
//     // "subevents": subtemplatesArr,
//     "thumbnail_image":"thumbnail"
//   }
//   // console.log(JSON.stringify(payload))

//   const response = await fetch(`${API_URL}/events`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(payload),
//   });

//   if (!response.ok) throw response.Error; 
//   // //new Error("Failed to save event");
//   return await response.json();
// }

export async function getEventById(eventId) {
  const response = await fetch(`${API_URL}/events/${eventId}`);
  if (!response.ok) throw new Error("Failed to fetch event");
  return await response.json();
}

export async function saveEvent({ mainEvent, eventId }) {
  const method =  (!eventId) ? "POST":  "PUT"
  const api = (!eventId) ? `${API_URL}/events/`:  `${API_URL}/events/${eventId}`

  const response = await fetch(api, {
    method: method,
    headers: {
      'Authorization': `Bearer ${getToken()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(mainEvent),
  });

  if (!response.ok) throw await buildApiError(response, "Failed to save event");
  return await response.json();
}

export async function deleteEvent(eventId) {
  const headers = {
    Authorization: `Bearer ${getToken()}`,
    Accept: "application/json",
  };

  let response = await fetch(`${API_URL}/events/${eventId}`, {
    method: "DELETE",
    headers,
  });

  if (response.status === 405) {
    response = await fetch(`${API_URL}/events/${eventId}/`, {
      method: "DELETE",
      headers,
    });
  }

  if (!response.ok) throw await buildApiError(response, "Failed to delete event");

  return await response.json();
}
